export const fleekActions = {
  TOGGLE_MODAL: 'TOGGLE_MODAL',
  FETCH_FEED_DATA_REQUEST: 'FETCH_FEED_DATA_REQUEST',
  FETCH_FEED_DATA_SUCCESS: 'FETCH_FEED_DATA_SUCCESS',
  FETCH_FEED_DATA_FAILURE: 'FETCH_FEED_DATA_FAILURE',

  // STORIES ACTIONS
  FETCH_FEED_STORIES_DATA_REQUEST: 'FETCH_FEED_STORIES_DATA_REQUEST',
  FETCH_FEED_STORIES_DATA_SUCCESS: 'FETCH_FEED_STORIES_DATA_SUCCESS',
  FETCH_FEED_STORIES_DATA_FAILURE: 'FETCH_FEED_STORIES_DATA_FAILURE',

  FETCH_EXPLORE_DATA_REQUEST: 'FETCH_EXPLORE_DATA_REQUEST',
  FETCH_EXPLORE_DATA_SUCCESS: 'FETCH_EXPLORE_DATA_SUCCESS',
  FETCH_EXPLORE_DATA_FAILURE: 'FETCH_EXPLORE_DATA_FAILURE',
  // Feed State handlers
  POST_SEEN: 'POST_SEEN',
  RESET_POST_SEEN: 'RESET_POST_SEEN',
  POSTS_SEND_TO_SES: 'POST_SEND_TO_SES',
  SHOW_SPLASH_SCREEN: 'SHOW_SPLASH_SCREEN',
  SHOW_COACHMARK_SCREEN: 'SHOW_COACHMARK_SCREEN',
  UPDATE_FEED_SCROLL_POSITION: 'UPDATE_FEED_SCROLL_POSITION',
  POST_LIKED: 'POST_LIKED',
  BRAND_FOLLOWED: 'BRAND_FOLLOWED',
  // Explore State handler
  UPDATE_EXPLORE_SCROLL_POSITION: 'UPDATE_EXPLORE_SCROLL_POSITION',
  FETCH_EXPLORE_ALL_BRANDS_REQUEST: 'FETCH_EXPLORE_ALL_BRANDS_REQUEST',
  FETCH_EXPLORE_ALL_BRANDS_SUCCESS: 'FETCH_EXPLORE_ALL_BRANDS_SUCCESS',
  FETCH_EXPLORE_ALL_BRANDS_FAILURE: 'FETCH_EXPLORE_ALL_BRANDS_FAILURE',
  FETCH_BRANDS_PAGE_DATA_REQUEST: 'FETCH_BRANDS_PAGE_DATA_REQUEST',
  FETCH_BRANDS_PAGE_DATA_SUCCESS: 'FETCH_BRANDS_PAGE_DATA_SUCCESS',
  FETCH_BRANDS_PAGE_DATA_FAILURE: 'FETCH_BRANDS_PAGE_DATA_FAILURE',
  // NOTE: BRAND PAGE POST DATA ACTION TYPES
  FETCH_BRANDS_PAGE_RECENT_POSTS_DATA_REQUEST: 'FETCH_BRANDS_PAGE_RECENT_POSTS_DATA_REQUEST',
  FETCH_BRANDS_PAGE_RECENT_POSTS_DATA_SUCCESS: 'FETCH_BRANDS_PAGE_RECENT_POSTS_DATA_SUCCESS',
  FETCH_BRANDS_PAGE_RECENT_POSTS_DATA_FAILURE: 'FETCH_BRANDS_PAGE_RECENT_POSTS_DATA_FAILURE',
  UPDATE_BRANDS_PAGE_RECENT_POSTS_DATA_SUCCESS: 'UPDATE_BRANDS_PAGE_RECENT_POSTS_DATA_SUCCESS',

  // NOTE: FOR FETCHING POSTDATA
  FETCH_INDIVIDUAL_POST_DATA_REQUEST: 'FETCH_INDIVIDUAL_POST_DATA_REQUEST',
  FETCH_INDIVIDUAL_POST_DATA_SUCCESS: 'FETCH_INDIVIDUAL_POST_DATA_SUCCESS',
  FETCH_INDIVIDUAL_POST_DATA_FAILURE: 'FETCH_INDIVIDUAL_POST_DATA_FAILURE',
  RESET_INDIVIDUAL_POST_DATA: 'RESET_INDIVIDUAL_POST_DATA',

  // NOTE: MINI PLP ACTION TYPES
  FETCH_MINI_PLP_DATA_REQUEST: 'FETCH_MINI_PLP_DATA_REQUEST',
  FETCH_MINI_PLP_DATA_SUCCESS: 'FETCH_MINI_PLP_DATA_SUCCESS',
  FETCH_MINI_PLP_DATA_FAILURE: 'FETCH_MINI_PLP_DATA_FAILURE',

  WISHILIST_OPTIONS_CODE_UPDATED: 'WISHILIST_OPTIONS_CODE_UPDATED',

  // NOTE: CATEGORIES ACTION FOR AJIOGRAM LANDING PAGE
  SET_CATEGORIES_STATE: 'SET_CATEGORIES_STATE'
};

export const storyActions = {
  SET_STORY_ID: 'SET_STORY_ID',
  CLOSE_STORY: 'CLOSE_STORY',
  SUB_STORY_SEEN: 'SUB_STORY_SEEN',
  STORY_SEEN: 'STORY_SEEN',
  RESET_STORY_SEEN: 'RESET_STORY_SEEN',
  STORYS_SEND_TO_SES: 'STORY_SEND_TO_SES',
  UPDATE_STORIES: 'UPDATE_STORIES'
};
